export const NUTRIENTS = [
  { key: 'kcal', label: 'Calorías', unit: 'kcal' },
  { key: 'protein', label: 'Proteínas', unit: 'g' },
  { key: 'carbs', label: 'Carbohidratos', unit: 'g' },
  { key: 'fat', label: 'Grasas', unit: 'g' },
  { key: 'fiber', label: 'Fibra', unit: 'g' },
  { key: 'sugar', label: 'Azúcares', unit: 'g' },
  { key: 'sodium', label: 'Sodio', unit: 'mg' },
];
export const MEALS = ['Desayuno', 'Media mañana', 'Almuerzo', 'Merienda', 'Cena', 'Otro'];
export const positive = value => value !== '' && value != null && Number.isFinite(Number(value)) && Number(value) > 0;
export const nonnegative = value => value !== '' && value != null && Number.isFinite(Number(value)) && Number(value) >= 0;
export const localDate = (date = new Date()) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const localTime = () => new Date().toTimeString().slice(0, 5);
export const displayNumber = value => value == null ? 'Sin dato' : new Intl.NumberFormat('es', { maximumFractionDigits: 1 }).format(value);
export const normalizeSearch = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export const emptyNutrients = () => Object.fromEntries(NUTRIENTS.map(({ key }) => [key, 0]));
export function sumNutrients(items) {
  return Object.fromEntries(NUTRIENTS.map(({ key }) => [key,
    items.some(item => item.nutrients[key] == null) ? null : items.reduce((sum, item) => sum + item.nutrients[key], 0),
  ]));
}
export function scaleNutrients(nutrients, factor) {
  if (!Number.isFinite(factor) || factor < 0) throw new Error('Cantidad inválida.');
  return Object.fromEntries(NUTRIENTS.map(({ key }) => [key, nutrients[key] == null ? null : nutrients[key] * factor]));
}
export function unitsFor(food) {
  const base = food.baseUnit === 'ml'
    ? [{ id: 'ml', label: 'ml', amount: 1 }, { id: 'l', label: 'litro', amount: 1000 }]
    : [{ id: 'g', label: 'g', amount: 1 }, { id: 'kg', label: 'kg', amount: 1000 }, { id: 'oz', label: 'onza', amount: 28.349523125 }];
  return [...base, ...(food.portions || [])];
}
export function foodSnapshot(food, quantity, unitId) {
  const unit = unitsFor(food).find(option => option.id === unitId);
  if (!positive(quantity) || !unit || !positive(unit.amount)) throw new Error('Selecciona una cantidad y unidad válidas.');
  const baseAmount = Number(quantity) * unit.amount;
  return { itemId: food.id, kind: 'food', name: food.name, quantity: Number(quantity), unitId,
    unitLabel: unit.label, baseAmount, baseUnit: food.baseUnit,
    nutrients: scaleNutrients(food.nutrients, baseAmount / 100), source: food.source };
}
export function recipeUnits(recipe) {
  return [{ id: 'serving', label: 'porción', amount: 1 / recipe.servings }, { id: 'whole', label: 'receta completa', amount: 1 },
    ...(positive(recipe.finalWeight) ? [{ id: 'g', label: 'g del plato terminado', amount: 1 / recipe.finalWeight }, { id: 'kg', label: 'kg del plato terminado', amount: 1000 / recipe.finalWeight }] : [])];
}
export function recipeSnapshot(recipe, quantity, unitId) {
  const unit = recipeUnits(recipe).find(option => option.id === unitId);
  if (!positive(quantity) || !positive(recipe.servings) || !unit) throw new Error('Cantidad de receta inválida.');
  return { itemId: recipe.id, kind: 'recipe', name: recipe.name, quantity: Number(quantity), unitId, unitLabel: unit.label,
    nutrients: scaleNutrients(sumNutrients(recipe.ingredients), Number(quantity) * unit.amount), source: 'Receta personal' };
}
export function validateFood(food) {
  if (!food.name.trim() || !['g', 'ml'].includes(food.baseUnit)) throw new Error('Escribe el nombre y la unidad base.');
  for (const { key, label } of NUTRIENTS) {
    const value = food.nutrients[key];
    if (key === 'kcal' || ![null, '', undefined].includes(value)) {
      if (!nonnegative(value)) throw new Error(`${label}: introduce un número mayor o igual a cero.`);
    }
  }
  if ((food.portions || []).some(p => !p.label.trim() || !positive(p.amount))) throw new Error('Cada porción necesita un nombre y una equivalencia positiva.');
}
export function validateRecipe(recipe) {
  if (!recipe.name.trim() || !positive(recipe.servings) || !recipe.ingredients.length) throw new Error('La receta necesita nombre, ingredientes y un número de porciones mayor que cero.');
  if (recipe.finalWeight !== '' && recipe.finalWeight != null && !positive(recipe.finalWeight)) throw new Error('El peso final debe ser mayor que cero.');
}
export function validateEntry(entry) {
  const parsed = new Date(`${entry.date}T12:00:00`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(entry.date) || Number.isNaN(parsed.getTime()) || localDate(parsed) !== entry.date || !/^([01]\d|2[0-3]):[0-5]\d$/.test(entry.time)) throw new Error('Introduce una fecha y hora válidas.');
  if (!MEALS.includes(entry.meal) || !entry.items.length) throw new Error('Añade al menos un alimento o receta.');
}
